// /frontend/src/utils/setAuthToken.js
import axios from 'axios';

/**
 * Sets the Authorization header for all axios requests
 * @param {string} token - JWT token
 */
const setAuthToken = (token) => {
    console.log(token)
  if (token) {
    // Set auth token in Authorization header for all requests
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    // Remove auth header if no token
    delete axios.defaults.headers.common['Authorization'];
  }
};

export default setAuthToken;